import React from 'react';
import { string, node } from 'prop-types';

const List = ({ className, children }) =>
  <ul className={className}>
    {children}
  </ul>;

List.propTypes = {
  className: string,
  children: node,
};

export default List;



// WEBPACK FOOTER //
// ./src/components/DataPanel/Overview/List/index.js